<template lang="pug">
v-dialog#pemegangModal(
  v-model="openModal",
  persistent,
  width="50%",
  :fullscreen="$vuetify.breakpoint.xsOnly"
)
  v-form
    v-card(:height="modalHeightDynamic")
      v-card-title.headline.grey.lighten-2 Penanggung Jawab Sementara (PJS)
      v-card-text
        v-container
          v-layout(row, wrap)
            v-flex(xs12, sm6, class="px-2")
              v-text-field(
                label="Nama",
                append-icon="mdi-magnify"
                required,
                v-model="pjs",
                @keyup.enter="search",
                :rules="rules",
                @click:append="search"
              )
            v-flex(xs12, sm6, class="px-2")
              v-menu(
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dates"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              )
                template(v-slot:activator="{ on }")
                  v-text-field(
                    v-model="dateRangeText"
                    label="Leave date range"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  )
                v-card
                  v-date-picker(
                    v-model="dates"
                    range
                    scrollable
                    no-title
                  )
                  v-card-actions
                    v-spacer
                    v-btn(text @click="menu = false") Cancel
                    v-btn(color="primary" @click="updateDateRange()") OK
          v-layout(row, wrap)
            v-flex(xs12, sm12)
              v-data-table(
                :headers="tableData.headers",
                :items="tableData.items",
                :items-per-page="5"
              )
                template(v-slot:item.actions="{ item }")
                  v-checkbox.locationOptions(
                    small,
                    v-model="selected",
                    :value="item._id",
                    style="margin-top: 10px; margin-bottom: -10px"
                  )
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="closingModal") Close
        v-btn(color="blue darken-1", text, @click="saveData") Submit
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "ModalPJS",
  components: {},
  props:['pjsData','openModal','leaveUser'],
  mounted() {
    this.selected = this.pjsData.reduce((acc, cur) => {
      acc.push(cur.user_id);
      return acc;
    }, []);
    this.tableData.items = this.userList.reduce((acc, cur) => {
      if (this.selected.includes(cur._id)) acc.push(cur);
      return acc;
    }, [])

    this.modalHeightDynamic = false;
    this.getDateLeave()
  },
  data() {
    return {
      selected: [],
      pjs: "",
      modalHeight: "",
      tableData: {
        headers: [
          { text: "Nama PJS", value: "name", width: "95%" },
          { text: "Action", value: "actions" },
        ],
        items: [],
      },
      rules: [
        (value) =>
        (value && value.length >= 2) || 'Min 2 characters' || !this.searchBTn.input-value
      ],
      closing: false,
      docPelaporan: null,
      emptyUpload: new File([""], "", {
        type: "",
      }),

      // datepicker
      menu: false,
      dates: [],
    };
  },
  computed: {
    ...mapState([
      "API_URL",
      "tokenIsafe",
      "dataUsers",
      "userList"
    ]),
    modalHeightDynamic: {
      get() {
        return this.modalHeight;
      },
      set(val) {
        const delta = this.dynamicHeight(val);
        this.modalHeight = delta;
      },
    },
    dateRangeText () {
      return this.dates.join(' s/d ')
    },
  },
  methods: {
    formatDate (date) {
      return moment(date).format("YYYY-MM-DD")
    },
    dynamicHeight: function (search) {
      const isMobile = this.$vuetify.breakpoint.xsOnly;
      const mobileHeight = this.$vuetify.breakpoint.height;
      if (search) {
        if (this.tableData.items.length < 3) {
          return mobileHeight;
        }
        return "";
      }
      if (isMobile) {
        return `${mobileHeight}`;
      }
      return "";
    },
    search() {
      if (this.pjs.length >= 2) {
        const keywordToSearch = this.pjs;
        const keyword = keywordToSearch.toLowerCase();
        const searchResult = this.userList?.filter((data) => data.name.toLowerCase().indexOf(keyword) > -1);
        this.tableData.items = searchResult;
        this.selected = [...this.selected];
      }
    },
    updateDateRange() {
      const start = moment(this.dates[0]);
      const end = moment(this.dates[1]);
      let setDate = this.dates;
      if (start.isAfter(end)) setDate = [this.formatDate(end), this.formatDate(start)];
      this.$refs.menu.save(setDate);
    },
    saveData() {
      this.$emit("selectedPJS", {
        selected: this.selected,
        dates: this.dates
      });
      this.tableData.items = this.userList.reduce((acc, cur) => {
        if (this.selected.includes(cur._id)) acc.push(cur);
        return acc;
      }, [])
      this.pjs = '';
    },
    closingModal() {
      this.selected = this.pjsData
      this.tableData.items = this.pjsData.map(data =>{
        return {name : data}
      })
      this.pjs = '';
      this.$emit("closeModal", false);
    },
    async getDateLeave() {
      if (this.dataUsers.location[0] !== 'HO') return false;

      this.loading = true;
      await axios
        .get(this.API_URL+'/v1/employees/getDateLeaveUser', {
          headers: {"Authorization": `Bearer ${this.$store.state.token}`},
          params: {id: this.leaveUser._id}
        })
        .then(response => {
          const data = response.data.data;
          if (!data || Object.keys(data).length === 0) return false;
          this.dates = [data.startDate, data.endDate];
        })
        .catch(error => {
          console.error('Error fetching optionsAutoComplete:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    pjsData: function(val) {
      this.selected = val.map(data =>{
        return data.name
      })
      this.tableData.items = val.map(data =>{
        return {name : data.name}
      })
    }
  },
};
</script>

<style scoped>
.print-bg {
  background: rgb(204, 204, 204);
  padding-top: 10px;
}
.print-bg > div {
  text-align: center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin: 0 auto;
  display: inline-block;
  text-align: initial;
}
.view-width {
  width: 11.3cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding: 0 3px;
}
.padding-xy-5 {
  padding: 2px;
}
.padding-xy-1 {
  padding: 1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding: 8px 5px 0px;
  width: 35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding: 5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
  align-items: left;
}
.width-20p {
  width: 20%;
}
.width-25p {
  width: 25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align: top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top: 60px;
}
.blink {
  -webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink {
  to {
    color: #ffffff;
  }
}
@keyframes blink {
  to {
    color: #ffffff;
  }
}
@media print {
}
table {
  border-collapse: collapse;
}
.headerTable {
  border: 1px solid black;
  background-color: #cccccc;
}
.tableInput td {
  border: 1px solid black;
  padding-left: 5px;
}
.verMiddle {
  vertical-align: middle;
}
</style>